import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useTeamsForSeason = seasonId => {
    const dispatch = useDispatch();

    const teams = useSelector(
        // @ts-ignore
        state => state.teams[ `season_${ seasonId }` ]
    );

    useEffect( () => {
        if ( !teams ) {
            dispatch(
                // @ts-expect-error
                window.PULSE.app.redux.actions.teams
                    .API__FETCH_TEAMS
                    .request( seasonId )
            );
        }
    }, [ seasonId ] );

    return teams?.sort( ( a, b ) => a.name > b.name ? 1 : -1 );
};